module.exports = __webpack_public_path__ + "static/media/eternl.29183d09.svg";